(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-case-studies"] && !Shopify.designMode) return;
  try {
    
  const formatCaseStudyValue = (value, useGrouping) => {
    const roundedValue = Math.round(value);
    return useGrouping ? roundedValue.toLocaleString('en-US') : String(roundedValue);
  };

  const animateCaseStudyValue = (element) => {
    const finalValue = element.dataset.countUp.trim();
    const match = finalValue.match(/^([+-]?)([\d,.]+)(.*)$/);

    if (!match) {
      element.textContent = finalValue;
      return;
    }

    const prefix = match[1];
    const numericText = match[2];
    const suffix = match[3];
    const target = Number(numericText.replaceAll(',', ''));
    const useGrouping = numericText.includes(',');
    const duration = 950;
    let startTime;

    const updateValue = (timestamp) => {
      startTime ??= timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = target * easedProgress;

      element.textContent = `${prefix}${formatCaseStudyValue(currentValue, useGrouping)}${suffix}`;

      if (progress < 1) {
        requestAnimationFrame(updateValue);
      }
    };

    requestAnimationFrame(updateValue);
  };

  const initHomepageCaseStudies = (section) => {
    if (section.dataset.animationInitialized === 'true') return;

    section.dataset.animationInitialized = 'true';
    const counters = section.querySelectorAll('[data-count-up]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let observer;
    let revealed = false;
    let visibilityCheck;

    const revealSection = () => {
      if (revealed) return;

      revealed = true;
      section.classList.add('is-visible');
      counters.forEach((counter) => animateCaseStudyValue(counter));
      observer?.disconnect();
      window.clearInterval(visibilityCheck);
      window.removeEventListener('scroll', revealIfVisible);
      window.removeEventListener('resize', revealIfVisible);
    };

    const revealIfVisible = () => {
      const rect = section.getBoundingClientRect();

      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
        revealSection();
      }
    };

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealSection();
      return;
    }

    section.classList.add('is-motion-ready');
    observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        revealSection();
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
    window.addEventListener('scroll', revealIfVisible, { passive: true });
    window.addEventListener('resize', revealIfVisible);
    visibilityCheck = window.setInterval(revealIfVisible, 500);
    requestAnimationFrame(revealIfVisible);
  };

  document.querySelectorAll('[data-homepage-case-studies]').forEach(initHomepageCaseStudies);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('[data-homepage-case-studies]')) {
      initHomepageCaseStudies(event.target);
    }
    event.target.querySelectorAll('[data-homepage-case-studies]').forEach(initHomepageCaseStudies);
  });

  } catch(e) { console.error(e); }
})();
})();
